(function () {
    'use strict';

    angular
        .module('elogbooks.user.sites.files', []);
})();
